import { miniApp, themeParams, useSignal } from "@telegram-apps/sdk-react";
import { useEffect } from "react";
import themeConfg from "~/assets/theme";

interface useSetHeaderColor {
    themeKey: string;
}
export const useSetHeaderColor = ({ themeKey }: useSetHeaderColor) => {
    const isDark = useSignal(themeParams.isDark);

    useEffect(() => {
        const theme = isDark ? "dark" : "light";
        const colorsTheme = themeConfg.tgColors[theme];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const bgColor = colorsTheme[themeKey];
        try {
            miniApp.setHeaderColor(bgColor);
            miniApp.setBackgroundColor(bgColor);
            miniApp.setBottomBarColor(bgColor);
        } catch (err) {
            console.log("err:useSetHeaderColor", err);
        }
    }, [isDark, themeKey]);
};
